'use strict';

var AV = require('./index');
var useLiveQuery = require('./use-live-query');
var useAdatpers = require('./use-adapters');

module.exports = useAdatpers(useLiveQuery(AV));


//////////////////
// WEBPACK FOOTER
// ./~/leancloud-storage/dist/node/entry/index-live-query.js
// module id = 678
// module chunks = 0